import { PDF_STYLES } from './pdfStyles';

/**
 * Adds header and footer to each page of the PDF document.
 * @param {*} doc The jsPDF document instance
 * @param {*} fileName  The name of the file being exported
 * @param {*} options  Additional options, e.g., companyName
 */
export function addHeaderFooterToDoc(doc, fileName, options) {
    const addHeaderFooter = () => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const currentPage = doc.internal.getNumberOfPages();


        doc.setFontSize(PDF_STYLES.headerFontSize);
        doc.text(fileName, 30, 20, { align: 'left' });
        doc.text(options && options.companyName ? options.companyName : '', pageWidth - 30, 20, { align: 'right' });


        doc.setFontSize(PDF_STYLES.footerFontSize);
        doc.text(`Powered by GCORPcx — Page ${currentPage}`, pageWidth / 2, pageHeight - 8, { align: 'center' });
    };


    // call once for first page
    addHeaderFooter();


    // subscribe to addPage to redraw header/footer for new pages
    doc.internal.events.subscribe('addPage', () => {
        addHeaderFooter();
    });
}